module.exports = __webpack_public_path__ + "img/smallTruck-grey.75a57e9c.svg";